export const screenSize = 560;
